<app-collapsible-section class="waves-section" heading="Waves" [count]="dataSource.data.length">
  @if (defaults.isMersyAdminBranchExcellenceUser) {
    <div section-actions class="OrangeButton section-buttons">
      <button mat-raised-button (click)="openCreateWavePopup()" title="Create new Wave" class="btn btn-sm button-color-fix">
        Add Wave <mat-icon class="add-button icon-color-fix">add_box</mat-icon>
      </button>
    </div>
  }

  <div class="admin-table-scroll mat-elevation-z8">
    <table mat-table #itemsList
      [dataSource]="dataSource"
      multiTemplateDataRows
      class="mat-table-custom" id="waves">

      <ng-container matColumnDef="Select">
        <th mat-header-cell *matHeaderCellDef> </th>
        <td mat-cell *matCellDef="let element"
          (click)="onSelectWave(element)">
          @if (selectedWave.WaveId === element.WaveId) {
            <span class="material-icons" matTooltip="Collapse">
              expand_less
            </span>
          } @else {
            <span class="material-icons" matTooltip="More Details">
              expand_more
            </span>
          }
        </td>
      </ng-container>
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef> Name </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.Name"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="GroupFunction">
        <th mat-header-cell *matHeaderCellDef> Group Function </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.GroupFunction"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="StartDate">
        <th mat-header-cell *matHeaderCellDef> Start Date </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.StartDate | date:'yyyy-MM-dd HH:mm'"></p>
        </td>
      </ng-container>
      <ng-container matColumnDef="EndDate">
        <th mat-header-cell *matHeaderCellDef> End Date </th>
        <td mat-cell *matCellDef="let element">
          <p [innerHTML]="element.EndDate | date:'yyyy-MM-dd HH:mm'"></p>
        </td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element; let i = dataIndex">
          <button mat-icon-button matTooltip="Edit Wave" (click)="onEditWave(element)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button matTooltip="Remove Wave" (click)="onRemoveWave(element)">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="ChangeLog">
        <th mat-header-cell *matHeaderCellDef>Change Log</th>
        <td mat-cell *matCellDef="let element">
          <compact-history-button
            [item]="element"
            tooltip="View Change Log"
            buttonText="Get History"
            (historyClick)="onHistoryDetail($event, 'Wave')">
          </compact-history-button>
        </td>
      </ng-container>

      <tr mat-header-row class="tableheader" *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
      <tr mat-row *matRowDef="let element; let i = dataIndex; columns: columnsToDisplay;" class="item"
        [ngClass]="selectedWave.WaveId === element.WaveId ? 'orange-background':''">
      </tr>
    </table>
  </div>
</app-collapsible-section>

@if (selectedWave.WaveId !== -1) {
  <app-collapsible-section [heading]="'Wave ' + selectedWave.Name + ' Branch Data Configuration'" [collapsible]="false">
    @if (defaults.isMersyAdminBranchExcellenceUser) {
      <div section-actions class="OrangeButton section-buttons">
        <button mat-raised-button (click)="onClickDownloadBranchData()" title="Download Wave Branch Data" class="btn btn-sm button-color-fix">
          Download Wave <mat-icon class="add-button icon-color-fix">download</mat-icon>
        </button>
        <button mat-raised-button (click)="onClickUploadBranchData()" title="Upload Wave Branch Data" class="btn btn-sm button-color-fix">
          Upload Wave <mat-icon class="add-button icon-color-fix">upload</mat-icon>
        </button>
      </div>
    }
  </app-collapsible-section>
}
